import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// style imports
import { LinkButtonStyled } from './styles';

export default () => (
  <SectionContainer
    className='nmx-no-print'
    id='sustainability-impact-pdf-callout'
    backgroundVariant='darkDefault'
    themeType='darkTheme'
    moduleName='strong-text-callout-module'
    moduleVariation='A'>
    <Row>
      <Col align='center'>
        <Typography
          themeType='darkTheme'
          component='h2'
          disableBottomPadding>
          Get the 2024 Sustainability and Impact Report
        </Typography>
        <LinkButtonStyled
          id='esg-pdf-download-button'
          variant='buttonLinkPrimary'
          linkUrl='/assets/pdf/sustainability/2024-sustainability-and-impact-report.pdf'
          ariaLabel='2024 sustainability report PDF download'
          isInternalPdf
          themeType='darkTheme'>
          Download PDF
        </LinkButtonStyled>
      </Col>
    </Row>
  </SectionContainer>
);
